export const PLATAFORMA_BASCULANTE = {
    Codigo: 12,
    Nome: 'Plataforma Basculante',
    Modelo: '',
    Capa: null, 
    Imagens: [
        {
            Capa: true,
            Ativo: true,
            Url: "assets/IPB/Produtos/Plataforma_Basculante_Corte/plataforma_basculante_2.png"
        }
        , {
            Url: "assets/IPB/Produtos/Plataforma_Basculante_Corte/plataforma_basculante_1.png"
        }
        , {
            Url: "assets/IPB/Produtos/Plataforma_Basculante_Corte/plataforma_basculante_3.png"
        }
        , {
            Url: "assets/IPB/Produtos/Plataforma_Basculante_Corte/plataforma_basculante_4.png"
        }
        , {
            Url: "assets/IPB/Produtos/Plataforma_Basculante_Corte/plataforma_basculante_5.png"
        }
    ],
    Detalhes: [
        `Engate simples ou duplo`
        , `Lâmina de corte`
        , `Tampa traseira`
        , `Opcionais:`
        , ` - Acionamento Hidráulico (Exceto TB-1300)`
    ],
    Modelos: [
        { Modelo: `TB-1300`, Detalhes: `Medidas 1,3 x 1,0 x 0,4` },
        { Modelo: `TB-1600`, Detalhes: `Medidas 1,6 x 1,0 x 0,4` },
        { Modelo: `TB-1800`, Detalhes: `Medidas 1,8 x 1,0 x 0,4` },
        { Modelo: `TB-2000`, Detalhes: `Medidas 2,0 x 1,0 x 0,4` },
        { Modelo: `TB-2200`, Detalhes: `Medidas 2,20 x 1,0 x 0,4` }
    ]
}